import React from 'react';
import { ModalButton } from '../../../Button';
import { StyledModalEditImageHeader } from '../../../Styled/StyledEditImage';
import { FontWeightWrapper, MarginWrapper, StyledDefaultImagesErrorContent } from '../../../Styled/StyledWrappers';
import { COLORS } from '../../../../constants';

interface IReplaceImageErrorContent {
  color: string;
}

export const ReplaceImageErrorContent = (props: IReplaceImageErrorContent): JSX.Element => {
  const { color } = props;

  const onButtonClick = () => {
    window.open('https://cengage.com.au/contact-us', '_blank');
  };

  return (
    <StyledDefaultImagesErrorContent className="default-images-error-content">
      <StyledModalEditImageHeader textColor={color}>Oops! Error.</StyledModalEditImageHeader>
      <span data-testid="error-modal-title">
        An <FontWeightWrapper weight={800}>error</FontWeightWrapper> has occurred and we were unable to upload the
        image. Contact Support if this error continues.
      </span>
      <MarginWrapper margin="37px 0px 0px 0px">
        <ModalButton bGColor={color} color={COLORS.white} text="Contact Support" onButtonClick={onButtonClick} />
      </MarginWrapper>
    </StyledDefaultImagesErrorContent>
  );
};
